<template>
  <div class="art-item item6-add-banner">
    <common-top :commonTopData="commonTopData"></common-top>
    <div class="page-title" v-text="pageTitle"></div>
    <div class="top-title">
      <el-form
        class="add-form"
        :model="addForm"
        :disabled="isDisabled"
        label-width="100px"
      >
        <el-form-item label="banner名称" prop="title">
          <el-input
            v-model="addForm.title"
            placeholder="请输入"
            maxlength="20"
            clearable
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="排序权重" prop="sort">
          <el-input
            v-model="addForm.sort"
            type="Number"
            placeholder="请输入 (限数字)"
            maxlength="30"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="content-title">内容配置</div>
      <!-- 内容配置表单 -->
      <el-form ref="form" :disabled="isDisabled" label-width="100px">
        <el-form-item label="banner图片">
          <w-upload-image
            style="overflow: hidden"
            class="upload-img"
            :imgWidth="1920"
            :imgHeight="620"
            :size="10"
            tipsText="建议375*340，支持图片（png/jpg）或视频（mp4）"
            v-model="addForm.prev_url"
          >
          </w-upload-image>
        </el-form-item>
        <el-form-item label="跳转内容">
          <el-radio-group
            class="art-radio-group"
            v-model="showObj.type"
            size="small"
          >
            <el-radio-button label="1">
              <span @click="setType(1)">专题列表</span>
            </el-radio-button>
            <el-radio-button label="2">
              <span @click="setType(2)">大图</span>
            </el-radio-button>
            <el-radio-button label="3">
              <span @click="setType(3)">视频</span>
            </el-radio-button>
            <el-radio-button label="4">
              <span @click="setType(4)">文章</span>
            </el-radio-button>
            <el-radio-button label="5">
              <span @click="setType(5)">链接</span>
            </el-radio-button>
          </el-radio-group>
          <!-- 跳转内容选择 -->
          <div class="item1" v-show="item === 1">
            <el-button @click="selectFn">选择专题列表</el-button>
            <span
              class="tips"
              v-text="
                `${showObj.relationName}（内容数：${showObj.relationContents}）`
              "
            ></span>
          </div>
          <div class="item2" v-show="item === 2">
            <w-upload-image
              style="overflow: hidden"
              class="upload-img"
              :imgWidth="1920"
              :imgHeight="620"
              :size="10"
              tipsText="png/jpg格式"
              v-model="showObj.bigPic"
            >
            </w-upload-image>
          </div>
          <div class="item3" v-show="item === 3">
            <w-upload-video
              style="overflow: hidden"
              :videoWidth="1920"
              :videoHeight="620"
              :size="10"
              tipsText="mp4格式"
              v-model="showObj.video"
            >
            </w-upload-video>
          </div>
          <div class="item4" v-show="item === 4">
            <el-button @click="selectFn2">选择文章</el-button>
            <span class="tips" v-text="`${showObj.relationName}`"></span>
          </div>
          <div class="item5" v-show="item === 5">
            <el-input
              v-model="showObj.link"
              placeholder="请输入跳转链接"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="foot-btn">
      <el-button size="small" @click="backFn">返回</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="isDisabled"
        @click="createFn"
        >创建</el-button
      >
    </div>

    <!-- 选择专题列表 -->
    <el-dialog
      title="选择专题列表"
      class="boxdop"
      :visible.sync="dialogVisible"
      width="100%"
      :before-close="handleClose"
    >
      <div class="dialog-table">
        <div class="feature">
          <div class="page-title">
            选择专题列表&nbsp;&nbsp;&nbsp;<span class="tips"
              >已根据展示位样式，筛选出建议选择的列表样式</span
            >
          </div>
          <span class="feature-item filter" @click="drawer = true"
            ><img src="@/assets/img/icon_sx.svg" />筛选</span
          >
        </div>
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column prop="id" label="列表ID"></el-table-column>
          <el-table-column prop="title" label="专题列表名称"></el-table-column>
          <el-table-column prop="display_type" label="列表展示样式">
            <template slot-scope="scope">
              <span v-if="scope.row.display_type == 1">横排画廊样式</span>
              <span v-if="scope.row.display_type == 2">大图+方图方式</span>
              <span v-if="scope.row.display_type == 3">图片列表样式</span>
              <span v-if="scope.row.display_type == 4">图片竖向播放样式</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="列表内容数"></el-table-column>
          <el-table-column prop="" label="存在关联跳转"></el-table-column>
          <el-table-column prop="create_at" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="lookBtn(scope.$index, scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="tips-box">
          <i class="icon el-icon-info"></i>
          <span class="info">共<em class="num" v-text="total"></em>条数据</span>
        </div>
        <!-- 抽屉 -->
        <el-drawer
          title="选择关联内容"
          class="drawer-box"
          :visible.sync="drawer"
          :before-close="handleClose"
        >
          <el-form :label-position="'top'" :model="form" ref="form">
            <el-form-item
              v-for="(item, index) in filterForm1"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
              <el-input
                v-model="form[item.prop]"
                autocomplete="off"
                :placeholder="item.pl"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="drawer-footer">
            <el-button @click="resetForm('form')">重 置</el-button>
            <el-button type="primary" @click="confirmFn">确 定</el-button>
          </div>
        </el-drawer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="savePopFn(0)"
          v-text="`确定`"
        ></el-button>
      </span>
    </el-dialog>

    <!-- 选择文章 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible2"
      width="100%"
      class="boxdop"
      :before-close="handleClose"
    >
      <div class="dialog-table">
        <div class="feature">
          <div class="page-title">选择文章</div>
          <span class="feature-item filter" @click="drawer = true"
            ><img src="@/assets/img/icon_sx.svg" />筛选</span
          >
        </div>
        <el-table
          :data="tableData2"
          @selection-change="handleSelectionChange"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column prop="id" label="文章ID"></el-table-column>
          <el-table-column prop="title" label="文章标题"></el-table-column>
          <el-table-column prop="classify" label="文章分类">
            <template slot-scope="scope">
              <div class="tags_d" v-html="backClass(scope.row)"></div>
            </template>
          </el-table-column>
          <el-table-column prop="tags" label="标签">
            <template slot-scope="scope">
              <div class="tags_d" v-html="backTag(scope.row)"></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="relation_jump"
            label="当前关联跳转"
          ></el-table-column>
          <el-table-column prop="creator" label="创建人"></el-table-column>
          <el-table-column prop="create_at" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="lookBtn(scope.$index, scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="tips-box">
          <i class="icon el-icon-info"></i>
          <span class="info">共<em class="num" v-text="total"></em>条数据</span>
        </div>
        <!-- 抽屉 -->
        <el-drawer
          title="选择关联内容"
          class="drawer-box"
          :visible.sync="drawer"
          :before-close="handleClose"
        >
          <el-form :label-position="'top'" :model="form" ref="form">
            <el-form-item
              v-for="(item, index) in filterForm2"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
              <el-input
                v-model="form[item.prop]"
                autocomplete="off"
                :placeholder="item.pl"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="drawer-footer">
            <el-button @click="resetForm('form')">重 置</el-button>
            <el-button type="primary" @click="confirmFn">确 定</el-button>
          </div>
        </el-drawer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button
          type="primary"
          @click="savePopFn(1)"
          v-text="`确定`"
        ></el-button>
      </span>
    </el-dialog>
    <component
      @sucss="savePopFn"
      @close="close"
      v-bind:is="componentName"
      v-model="componentData"
    ></component>
  </div>
</template>

<script>
import commonTop from "@/components/commonTop.vue";
import { checkURL } from "@/common/utils";
import com_zt_list from "./com_zt_list.vue";
import com_wz_list from "./com_wz_list.vue";
export default {
  components: {
    commonTop,
    com_zt_list,
    com_wz_list,
  },
  data() {
    // 这里存放数据
    return {
      componentName: "",
      componentData: {},
      showObj: {
        type: 1,
      },
      pageTitle: "新建banner",
      id: this.$route.query.id,
      type: this.$route.query.type,
      drawer: false,
      dialogVisible: false,
      dialogVisible2: false,
      commonTopData: {
        commonleftbtn: [],
      },
      addForm: {
        id: "", // 选中专题列表id
        title: "",
        sort: "",
        prev_url: "",
        bigPic: "",
        video: "",
        link: "",
        type: "1",
        relationName: "专题名称",
        relationContents: "0",
        num: "",
        display_type: "",
        jump_type: "",
        jump_to: "",
      },
      isDisabled: false, // 是否禁用
      tmpVisible: false, // 专题列表是否显示
      item: 1,
      form: {
        id: "",
        title: "",
        author: "",
        tags: "",
      },
      filterForm1: [
        { prop: "id", label: "内容ID", pl: "请输入内容ID检索" },
        { prop: "title", label: "内容标题", pl: "请输入文章标题检索" },
        { prop: "author", label: "创作者昵称", pl: "请输入创作者检索" },
        { prop: "tags", label: "标签", pl: "请输入标签检索" },
      ],
      filterForm2: [
        { prop: "id", label: "文章ID", pl: "请输入内容ID检索" },
        { prop: "title", label: "文章标题", pl: "请输入文章标题检索" },
        { prop: "type", label: "文章分类", pl: "请选择文章分类检索" },
        { prop: "tags", label: "标签", pl: "请输入标签检索" },
        { prop: "author", label: "创建人", pl: "请输入创建人检索" },
      ],
      selectedData: "", // 已选择项目
      tableData: [],
      tableData2: [],
      total: "",
      total2: "",
    };
  },
  mounted() {
    if (this.type === "look") {
      this.pageTitle = "banner详情";
      this.isDisabled = true;
      this.bannerDetail();
    }
    if (this.type === "edit") {
      this.pageTitle = "编辑banner";
      this.isDisabled = false;
      this.bannerDetail();
    }
  },
  // 方法集合
  methods: {
    setType(n) {
      if (this.item == n) {
        return;
      }
      this.item = n;
      this.showObj = {
        type: n,
      };
    },
    close() {
      this.componentName = "";
    },
    backClass(da) {
      let classify = [];
      try {
        classify = JSON.parse(da.classify);
      } catch (error) {console.log(error)}
      return classify.join("/");
    },
    backTag(da) {
      let arr = [];
      try {
        arr = JSON.parse(da.tags);
      } catch (error) {console.log(error)}
      let str = "";
      arr.map((e) => {
        str += `<span>${e}</span>`;
      });
      return str;
    },
    selectFn() {
      this.componentName = "com_zt_list";
    },
    selectFn2() {
      this.componentName = "com_wz_list";
    },
    // 创建banner
    createFn() {
      let type = this.showObj.type;
      let data = {
        title: this.addForm.title,
        sort: this.addForm.sort,
        channel: "qudu",
        page_id: "home",
        display_type: type,
        jump_type: this.showObj.type,
        prev_url: this.addForm.prev_url,
        jump_to:
          type == 1
            ? this.showObj.id
            : type == 2
            ? this.showObj.bigPic
            : type == 3
            ? this.showObj.video
            : type == 4
            ? this.showObj.id
            : type == 5
            ? this.showObj.link
            : "other",
        // position_id: 0 暂不传
      };
      if (!this.addForm.title) {
        this.$message.warning("名称不能为空");
        return;
      }
      if (!this.addForm.sort) {
        this.$message.warning("排序权重不能为空");
        return;
      }
      if (!this.addForm.prev_url) {
        this.$message.warning("banner图不能为空");
        return;
      }
      if (type == 1 && this.type == "look" && !this.showObj.id) {
        this.$message.warning("专题列表不能为空");
        return;
      }
      if (type == 2 && !this.showObj.bigPic) {
        this.$message.warning("大图不能为空");
        return;
      }
      if (type == 3 && !this.showObj.video) {
        this.$message.warning("视频不能为空");
        return;
      }
      if (type == 5 && !this.showObj.link) {
        this.$message.warning("链接不能为空");
        return;
      }
      if (type == 5 && !checkURL(this.showObj.link)) {
        this.$message.warning("请输入正确的url");
        return;
      }

      if (this.type == "add") {
        this.api.addBanner(data).then((res) => {
          if (!res) return;
          this.$message("创建成功");
          this.$router.push("/art/item6?tabs=bannerList");
        });
      }
      if (this.type == "edit") {
        data.id = this.id;
        this.api.editBanner(data).then((res) => {
          if (!res) return;
          this.$message.success("编辑成功");
          this.$router.push("/art/item6?tabs=bannerList");
        });
      }
    },
    getPopData() {
      this.api.subjectList().then((res) => {
        if (!res) return;
        let { data, total } = res;

        this.tableData = data;
        this.total = total;
      });
    },
    getPopData2() {
      this.api.getArticleList().then((res) => {
        if (!res) return;
        let { data, total } = res;
        this.tableData2 = data;
        this.total2 = total;
      });
    },
    // banner详情
    bannerDetail() {
      let data = {
        id: this.id,
      };
      this.api.bannerDetail(data).then((res) => {
        if (!res) return;
        this.addForm.title = res.title;
        this.addForm.sort = res.sort;
        this.addForm.num = res.face_display_num;
        this.addForm.prev_url = res.prev_url;

        /*跳转内容*/
        this.showObj.type = res.jump_type;
        this.item = +res.jump_type;
        this.showObj.id = res.jump_to;
        this.showObj.link = res.jump_to;
        this.showObj.video = res.jump_to;
        this.showObj.bigPic = res.jump_to;
        this.showObj.relationName = res.relation_title;
        this.showObj.relationContents = res.relation_contents;
      });
    },
    savePopFn(da) {
      this.close();
      if (!da) {
        return;
      }
      this.showObj.id = da.id;
      this.showObj.relationName = da.title;
      this.showObj.relationContents = da.relation_subject_contents;
      this.showObj.display_type = da.display_type;
      this.showObj.jump_type = da.type;
      this.showObj.jump_to = da.jump_to;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 全选事件
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    lookBtn() {
      this.$message("look");
    },
    backFn() {
      this.$router.push("/art/item6?tabs=bannerList");
    },
    // 抽屉确定
    confirmFn() {},
    handleClose(done) {
      done();
      this.tmpVisible = false;
    },
  },
};
</script>
<style>
.boxdop .el-dialog__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
}
.boxdop .el-dialog__body {
  padding-bottom: 70px !important;
}
</style>
<style lang='scss' scoped>
.item6-add-banner {
  height: 98vh;
  background-color: #fff;
  .page-title {
    margin: 0 0 30px 30px;
    font-size: 16px;
  }
  .top-title {
    padding-left: 150px;
    .add-form {
      .tips {
        color: #979797;
      }
    }
    .title-item {
      display: flex;
      margin-bottom: 15px;
      .select-btn {
        display: inline-block;
        width: 110px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        border: 1px solid #c4c4c4;
      }
    }
  }
  .content {
    position: relative;
    margin-top: 30px;
    padding-left: 150px;
    border-top: 1px solid #e5e5e5;
    .content-title {
      display: inline;
      position: relative;
      left: -120px;
    }
    .tips {
      margin-left: 10px;
      display: inline;
      color: #828282;
    }
    .all-online {
      width: 400px;
      margin: 20px 0 10px;
      text-align: right;
      cursor: pointer;
      color: #33b3ff;
    }
    .art-radio-group {
      margin-bottom: 10px;
    }
    .el-form-item {
      position: relative;
    }
  }
  .foot-btn {
    .el-button {
      width: 100px;
    }
  }
  .el-input,
  .el-select,
  .el-textarea {
    width: 460px !important;
    /deep/.el-input__count {
      bottom: -10px;
    }
  }
}
</style>

<style lang="scss">
.item6-add-banner {
  overflow: hidden;
  overflow-y: auto;
  .upload-img {
    .w-upload-image-review {
      width: 360px;
      min-height: 0;
      img {
        border: 1px dashed #999;
        border-radius: 4px;
      }
    }
  }
}
</style>
<style >
.tags_d > span {
  display: inline-block;
  vertical-align: top;
  padding: 2px 5px;

  margin: 2px;
  font-size: 12px;
  border-radius: 5px;
  color: #fff;
  background-color: whitesmoke;

  color: #979797;
  border: 1px solid #eaeaea;
}
</style>

